<div class="notification-logs">
    <!-- <div class="logs-header">
        <div>
            <p class="logs-breadcrumb">Centro de notificaciones / Logs</p>
            <h2>Inbox de notificaciones</h2>
            <small class="text-muted">Consulta el historial y estado de todos los envíos</small>
        </div>
        <div class="header-actions">
            <button class="btn btn-outline-primary" (click)="toggleStatistics()">
                <i class="ti ti-chart-bar"></i> {{ showStatistics ? 'Ocultar' : 'Ver' }} estadísticas
            </button>
            <button class="btn btn-outline-warning" (click)="retryFailedNotifications()">
                <i class="ti ti-refresh"></i> Reintentar fallidas
            </button>
            <button class="btn btn-outline-danger" (click)="cleanupOldLogs()">
                <i class="ti ti-trash"></i> Limpieza
            </button>
        </div>
    </div> -->

    <!-- <div *ngIf="showStatistics" class="stats-grid">
        <div class="stat-card total">
            <span>Total</span>
            <strong>{{ statistics.total_notifications || 0 }}</strong>
        </div>
        <div class="stat-card success">
            <span>Enviadas</span>
            <strong>{{ statistics.sent_notifications || 0 }}</strong>
        </div>
        <div class="stat-card warning">
            <span>Pendientes</span>
            <strong>{{ statistics.pending_notifications || 0 }}</strong>
        </div>
        <div class="stat-card danger">
            <span>Fallidas</span>
            <strong>{{ statistics.failed_notifications || 0 }}</strong>
        </div>
        <div class="stat-card info">
            <span>Push</span>
            <strong>{{ statistics.push_notifications || 0 }}</strong>
        </div>
        <div class="stat-card secondary">
            <span>WhatsApp</span>
            <strong>{{ statistics.whatsapp_notifications || 0 }}</strong>
        </div>
    </div> -->

    <!-- <div class="toolbar">
        <div class="tabs">
            <button *ngFor="let tab of statusTabs" type="button"
                [class.active]="activeStatusValue === tab.value"
                (click)="selectStatusTab(tab.value)">
                {{ tab.label }}
            </button>
        </div>
        <div class="toolbar-actions">
            <div class="search-wrapper">
                <i class="ti ti-search"></i>
                <input #searchInput type="text" placeholder="Buscar por título o mensaje"
                    (input)="onSearch(searchInput.value)">
            </div>
            <form class="filters" [formGroup]="filterForm">
                <select formControlName="type" (change)="onFilterChange()">
                    <option value="">Tipo: Todos</option>
                    <option value="push">Push</option>
                    <option value="whatsapp">WhatsApp</option>
                </select>
                <input type="date" formControlName="date_from" (change)="onFilterChange()">
                <input type="date" formControlName="date_to" (change)="onFilterChange()">
                <button type="button" class="btn btn-link" (click)="clearFilters()">Limpiar</button>
            </form>
        </div>
    </div> -->

    <div class="col-xl">
        <div class="card">
            <div class="card-body">
                <div class="rounded">
                    <div class="row">
                        <div class="col">
                            <div *ngIf="loading" class="state-card loading">
                                <div class="spinner-border" role="status"></div>
                                <p>Cargando notificaciones...</p>
                            </div>

                            <div *ngIf="!loading && logs.length === 0" class="state-card empty">
                                <img src="assets/img/illustrations/empty-mail.svg" alt="Sin datos" />
                                <h4>No hay registros</h4>
                                <p>Cuando se envíen nuevas notificaciones aparecerán aquí.</p>
                            </div>
                            <div *ngIf="!loading && logs.length > 0" class="logs-layout">
                                <div class="log-list">
                                    <div class="row">
                                        <div class="col">
                                           <h3 class="mb-0">Notificaciones</h3>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col mb-3">
                                            <div class="search-wrapper">
                                                <input #searchInput type="text" placeholder="Buscar por título o mensaje"
                                                    (input)="onSearch(searchInput.value)" class="form-control">
                                                <i class="ti ti-search"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="log-card" *ngFor="let log of filteredLogs" (click)="selectLog(log)"
                                        [class.active]="log.id === selectedLog?.id">
                                        <div class="log-card__header">
                                            <div>
                                                <h5>{{ log.title }}</h5>
                                                <small>{{ log.notification_configuration?.title ||
                                                    log.notification_configuration?.name ||
                                                    'Configuración' }}</small>
                                            </div>
                                            <div class="chips">
                                                <span class="chip" [class]="getTypeChipClass(log.type)">{{
                                                    getTypeText(log.type) }}</span>
                                                <span class="chip" [class]="getStatusChipClass(log.status)">{{
                                                    getStatusText(log.status) }}</span>
                                            </div>
                                        </div>
                                        <p class="log-card__message">
                                            {{ log.message }}
                                        </p>
                                        <div class="log-card__meta">
                                            <span>{{ log.user?.name || 'Sin emisor' }}</span>
                                            <span>{{ getFormattedDate(log.created_at) }}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="log-detail" *ngIf="selectedLog as log; else selectPlaceholder">
                                    <div class="detail-header">
                                        <div>
                                            <!-- <p class="detail-label">{{ log.notification_configuration?.name ||
                                                'Registro' }}</p> -->
                                            <h4>{{ log.title }}</h4>
                                            <small>{{ getFormattedDate(log.created_at || '') }}</small>
                                        </div>
                                        <!-- <div class="chips">
                                            <span class="chip" [class]="getTypeChipClass(log.type || '')">
                                                {{ getTypeText(log.type || '') }}
                                            </span>
                                            <span class="chip" [class]="getStatusChipClass(log.status || '')">
                                                {{ getStatusText(log.status || '') }}
                                            </span>
                                        </div> -->
                                    </div>

                                    <div class="detail-body">
                                        <p class="detail-message">{{ log.message }}</p>

                                        <div class="detail-meta">
                                            <div>
                                                <span>Usuario</span>
                                                <strong>{{ log.user?.name || 'Sin registro' }}</strong>
                                            </div>
                                            <div>
                                                <span>Teléfono</span>
                                                <strong>{{ log.recipient_phone || 'N/A' }}</strong>
                                            </div>
                                            <div>
                                                <span>Enviado</span>
                                                <strong>{{ getFormattedDate(log.sent_at || '') }}</strong>
                                            </div>
                                        </div>

                                        <div *ngIf="log.metadata" class="detail-metadata">
                                            <span>Metadata</span>
                                            <pre>{{ log.metadata | json }}</pre>
                                        </div>

                                        <div *ngIf="log.error_message" class="detail-error">
                                            <span>Error reportado</span>
                                            <p>{{ log.error_message }}</p>
                                        </div>
                                    </div>
                                </div>

                                <ng-template #selectPlaceholder>
                                    <div class="log-detail placeholder">
                                        <h4>Selecciona un registro</h4>
                                        <p>Haz clic en una notificación del listado para ver el detalle completo.</p>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>



    <div *ngIf="!loading && logs.length > 0" class="pagination-wrapper">
        <button class="btn btn-outline-secondary" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">
            <i class="ti ti-chevron-left"></i>
        </button>
        <span>Página {{ currentPage }} de {{ totalPages }}</span>
        <button class="btn btn-outline-secondary" (click)="goToPage(currentPage + 1)"
            [disabled]="currentPage === totalPages">
            <i class="ti ti-chevron-right"></i>
        </button>
    </div>
</div>